// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';
import { dispatchEvent } from '../dispatch-event/dispatch-event.tsx';
import type { TaskId } from '../../../tasks/constants.tsx';

export const setOpenTaskId =
	({ id }: { id: TaskId }): Action<State> =>
	async ({ setState, dispatch }) => {
		setState({ openTaskId: id });
		dispatch(dispatchEvent({ type: 'opened-task-change', taskId: id }));
	};
